import React from 'react'
import Image from 'components/Common/Image'

export const StepsHowItWorks = [
  {
    image: <Image style={{ height: 40 }} id="tcqw0293hnq17bzcd78d" alt="Step 1" quality="eco" />,
    title: 'Pay in four instalments over six weeks.',
    description: 'Pay your first instalment at the time of purchase, and the rest every two weeks.',
  },
  {
    image: <Image style={{ height: 40 }} id="2ejw6szt8h4fesu9j1s" alt="Step 2" quality="eco" />,
    title: 'Enjoy no fees when you pay on time.',
    description: 'The only fees are late payments but, don’t worry, Afterpay will send regular reminders.',
  },
  {
    image: <Image style={{ height: 40 }} id="zndk0xexpwvqcsq6b84" alt="Step 3" quality="eco" />,
    title: 'Get instant approval in seconds.',
    description: 'Know you’ve been approved almost instantly.',
  },
]

export const StepsBuyNow = [
  {
    title: '1',
    description: 'Browse your favourite escapes',
  },
  {
    title: '2',
    description: 'Instantly create an account and complete your purchase',
  },
  {
    title: '3',
    description: 'Choose Afterpay as your payment method',
  },
]
